import { Container, Text, Spacer, Button, Card } from "@nextui-org/react";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { getHello, getHelloAuth, getApiBaseUrl, getTestTask } from "../../config/api";
import { useAuth } from "../../context/AuthContext";

const TestApiPage = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const [apiResponse, setApiResponse] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleTestTask = async () => {
    setLoading(true);
    setApiResponse(null);
    try {
      const data = await getTestTask();
      setApiResponse(JSON.stringify(data, null, 2));
    } catch (error) {
      setApiResponse(`Error: ${error instanceof Error ? error.message : String(error)}`);
    } finally {
      setLoading(false);
    }
  };

  const handleTestApi = async () => {
    setLoading(true);
    setApiResponse(null);
    try {
      const data = await getHello();
      setApiResponse(JSON.stringify(data, null, 2));
    } catch (error) {
      setApiResponse(`Error: ${error instanceof Error ? error.message : String(error)}`);
    } finally {
      setLoading(false);
    }
  };

  const handleTestApiAuth403 = async () => {
    setLoading(true);
    setApiResponse(null);
    try {
      const data = await await getHelloAuth("xxx");
      setApiResponse(JSON.stringify(data, null, 2));
    } catch (error) {
      setApiResponse(`Error: ${error instanceof Error ? error.message : String(error)}`);
    } finally {
      setLoading(false);
    }
  };

  const handleTestApiAuth = async () => {
    if (!user) {
      setApiResponse("Error: User not logged in");
      return;
    }
    setLoading(true);
    setApiResponse(null);
    try {
      const token = await user.getIdToken();
      const data = await getHelloAuth(token);
      setApiResponse(JSON.stringify(data, null, 2));
    } catch (error) {
      setApiResponse(`Error: ${error instanceof Error ? error.message : String(error)}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container display="flex" direction="column" justify="center" alignItems="center" css={{ height: "100vh" }}>
      <Text h1>{t("testApi.title")}</Text>
      <Spacer y={1} />

      <Button onPress={handleTestTask} disabled={loading}>
        {loading ? "Loading..." : "Test Cloud Task"}
      </Button>

      <Button onPress={handleTestApi} disabled={loading}>
        {loading ? "Loading..." : "Test API /hello"}
      </Button>
      <Spacer y={1} />
      <Button onPress={handleTestApiAuth403} disabled={loading || !user} color="secondary">
        {loading ? "Loading..." : "Test API /hello-auth 403"}
      </Button>
      <Spacer y={1} />
      <Button onPress={handleTestApiAuth} disabled={loading || !user} color="secondary">
        {loading ? "Loading..." : "Test API /hello-auth"}
      </Button>
      <Spacer y={0.5} />
      <Text size="$xs" color="gray">API Base URL: {getApiBaseUrl()}</Text>

      {apiResponse && (
        <>
          <Spacer y={1} />
          <Card css={{ p: "$4", mw: "400px" }}>
            <Text h5>API Response:</Text>
            <Text as="pre" size="$xs" css={{ whiteSpace: "pre-wrap", wordBreak: "break-all" }}>
              {apiResponse}
            </Text>
          </Card>
        </>
      )}
    </Container >
  );
};

export default TestApiPage;
